import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import {
  PoModule,
  PoModalComponent,
  PoTableColumn,
  PoTableLiterals,
  PoNotificationService,
} from '@po-ui/ng-components';
import { LocalStorageType } from '../../types/localStorage.type';
import { downloadFile } from '../../utils/download.utils';
import { QrCode } from '../../utils/qrCode.utils';
import { CommonModule } from '@angular/common';
import { NgxBarcode6 } from 'ngx-barcode6';
import { SessionService } from '../../services/session.service';
import { Router } from '@angular/router';
import { TenantService } from '../../services/tenant.service';
import { clearSessionData } from '../../utils/clearSessionData.util';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { PaginationComponent } from '../../shared/components/pagination/pagination.component';

@Component({
  standalone: true,
  imports: [PoModule, CommonModule, NgxBarcode6, PaginationComponent],
  selector: 'payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.css'],
})
export class PaymentOptionsComponent {
  @ViewChild('modal1') modal1!: PoModalComponent;
  @ViewChild('modal2') modal2!: PoModalComponent;

  loadingSize: string = 'md';
  loadingText: string = '';
  isLoadingHidden = true;
  isMobile: boolean = window.innerWidth <= 768;
  public today: Date = new Date();
  isHiddenPersonName: boolean = true;
  currentPage: number = 1;
  isDisableShowMore: boolean = false;
  totalPages: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  public totals = {
    installmentValue: 0,
    discountValue: 0,
    increaseValue: 0,
    finalValue: 0,
  };

  constructor(
    private apiService: ApiService,
    private qrCodeService: QrCode,
    private poNotification: PoNotificationService,
    private sessionService: SessionService,
    private router: Router,
    private tenantService: TenantService,
  ) {
    registerLocaleData(ptBr, 'pt-BR');
  }

  async ngOnInit(): Promise<void> {
    await this.searchDocuments();
  }

  async searchDocuments() {
    if (!this.onValidToken()) return;

    this.isLoadingHidden = false;

    await this.apiService.setterHeader('PTCAPP001');
    let branchCodeList: string[] = [];
    const storageBranches = JSON.parse(
      localStorage.getItem(LocalStorageType.Branches) || '[]',
    );
    branchCodeList = storageBranches.map((item: any) => {
      const key = Object.keys(item)[0];
      return item[key].branchCode.toString();
    });

    const body = {
      page: this.currentPage,
      pageSize: this.pageSize,
      order: 'expiredDate',
    };

    this.apiService.postDocumentSearch(body).subscribe(
      (response) => {
        const storageBranches = JSON.parse(
          localStorage.getItem(LocalStorageType.Branches) || '[]',
        );
        this.totalPages = response.totalPages;
        this.totalItems = response.count;

        this.totals = response.items.reduce(
          (acc: any, item: any) => {
            return {
              installmentValue:
                0 + acc.installmentValue + (item.installmentValue || 0),
              discountValue:
                0 +
                acc.discountValue +
                (item.calculatedValues
                  ? item.calculatedValues.discountValue
                  : 0 + item.rebateValue || 0),
              increaseValue:
                0 +
                acc.increaseValue +
                (item.calculatedValues
                  ? item.calculatedValues.increaseValue
                  : 0 || 0),
              finalValue:
                0 +
                acc.finalValue +
                (item.calculatedValues
                  ? item.installmentValue -
                    item.calculatedValues.discountValue +
                    item.calculatedValues.increaseValue
                  : item.installmentValue - item.rebateValue || 0),
            };
          },
          {
            installmentValue: 0,
            discountValue: 0,
            increaseValue: 0,
            finalValue: 0,
          },
        );

        const novosItensMapeados = response.items.map((item: any) => {
          const branch = storageBranches.find(
            (branchItem: any) => branchItem[item.branchCode],
          );

          var personName = item.personName || '';
          if (this.isHiddenPersonName === true && personName.length > 0) {
            this.isHiddenPersonName = false;
            this.columns = this.columns.map((column) => {
              if (column.property === 'personName') {
                return { ...column, visible: true };
              }
              return column;
            });
          }

          return {
            branchCode: item.branchCode,
            fantasyName: branch ? branch[item.branchCode].fantasyName : null,
            personName: item.personName,
            receivableCode: item.receivableCode,
            installmentCode: item.installmentCode,
            issueDate: item.issueDate,
            expiredDate: item.expiredDate,
            installmentValue: item.installmentValue,
            daysLate: item.calculatedValues
              ? item.calculatedValues.daysLate
              : 0,
            discount: item.calculatedValues
              ? item.calculatedValues.discountValue
              : 0 + item.rebateValue,
            increase: item.calculatedValues
              ? item.calculatedValues.increaseValue
              : 0,
            finalValue: item.calculatedValues
              ? item.installmentValue -
                item.calculatedValues.discountValue +
                item.calculatedValues.increaseValue
              : item.installmentValue - item.rebateValue,
            invoice: {
              branchCode: item.branchCode,
              customerCode: item.customerCode,
              receivableCode: item.receivableCode,
              installmentNumber: item.installmentCode,
              isPortal: true,
              daysLate: item.calculatedValues
                ? item.calculatedValues.daysLate
                : 0,
              increaseValue: item.calculatedValues
                ? item.calculatedValues.increaseValue
                : 0,
              interestValue: item.calculatedValues
                ? item.calculatedValues.interestValue
                : 0,
              fineValue: item.calculatedValues
                ? item.calculatedValues.fineValue
                : 0,
              discountValue: item.calculatedValues
                ? item.calculatedValues.discountValue
                : 0,
              correctedValue: item.calculatedValues
                ? item.calculatedValues.correctedValue
                : 0,
            },
            barCode: item.barCode,
            digitableLine: item.digitableLine,
            qrCodePix: item.qrCodePix,
            columnIcon: this.generateDocumentsIcons(item),
          };
        });
        this.items = novosItensMapeados;
        this.isLoadingHidden = true;
      },
      (error) => {
        if (
          error.error &&
          Array.isArray(error.error) &&
          error.error.length > 0
        ) {
          const errorMessage = error.error[0].message || 'Erro desconhecido.';
          this.poNotification.error(errorMessage);
        } else if (error.message) {
          this.poNotification.error(error.message);
        } else {
          this.poNotification.error('Ocorreu um erro desconhecido.');
        }
        this.isLoadingHidden = true;
      },
    );
  }

  codigoBarras: string = '';
  linhaDigitavel: string = '';
  linkCopiaCola: string = '';
  qrCodeImageUrl: string = '';

  title = 'Carnês e Boletos';

  items!: Array<any>;

  columns: Array<PoTableColumn> = [
    { property: 'branchCode', label: 'Código', type: 'number', visible: false },
    {
      property: 'fantasyName',
      label: 'Empresa',
      type: 'string',
      visible: false,
    },
    {
      property: 'personName',
      label: 'Nome',
      type: 'string',
      color: this.changeColor.bind(this),
      visible: false,
    },
    {
      property: 'receivableCode',
      label: 'Fatura',
      type: 'number',
      color: this.changeColor.bind(this),
    },
    {
      property: 'installmentCode',
      label: 'Parcela',
      type: 'number',
      color: this.changeColor.bind(this),
    },
    {
      property: 'issueDate',
      label: 'Data de emissão',
      type: 'date',
      color: this.changeColor.bind(this),
    },
    {
      property: 'expiredDate',
      label: 'Data de vencimento',
      type: 'date',
      color: this.changeColor.bind(this),
    },
    {
      property: 'daysLate',
      label: 'Dias vencidos',
      type: 'number',
      color: this.changeColor.bind(this),
    },
    {
      property: 'installmentValue',
      label: 'Valor parcela',
      type: 'currency',
      format: 'BRL',
      color: this.changeColor.bind(this),
    },
    {
      property: 'discount',
      label: 'Abatimento',
      type: 'currency',
      format: 'BRL',
      color: this.changeColor.bind(this),
    },
    {
      property: 'increase',
      label: 'Juros/Multa',
      type: 'currency',
      format: 'BRL',
      color: this.changeColor.bind(this),
    },
    {
      property: 'finalValue',
      label: 'Valor líquido',
      type: 'currency',
      format: 'BRL',
      color: this.changeColor.bind(this),
    },
    {
      property: 'columnIcon',
      label: 'Forma de pagamento',
      type: 'icon',
      icons: [
        {
          value: 'pdf',
          icon: 'ph ph-file-pdf',
          color: 'color-01',
          tooltip: 'Baixar PDF',
          action: this.generatePDF.bind(this),
        },
        {
          value: 'barCode',
          icon: 'ph ph-barcode',
          color: 'color-01',
          tooltip: 'Código de barra',
          action: this.generateBarCode.bind(this),
        },
        {
          value: 'pix',
          icon: 'ph ph-pix-logo',
          color: 'color-01',
          tooltip: 'Gerar Pix',
          action: this.generateQrCodePix.bind(this),
        },
      ],
    },
  ];

  generatePDF(item: any) {
    if (!this.onValidToken()) return;

    this.apiService.postAction('OBTER_BOLETO').subscribe();
    this.isLoadingHidden = false;
    const body = item.invoice;

    this.apiService.postBankSlip(body).subscribe(
      (response) => {
        const base64String = response.content;
        const fileName = `Boleto_Ref_Fat_${item.invoice.receivableCode}_Parc_${item.invoice.installmentNumber}`;
        downloadFile(base64String, fileName, 'pdf');
        this.isLoadingHidden = true;
      },
      (error) => {
        if (
          error.error &&
          Array.isArray(error.error) &&
          error.error.length > 0
        ) {
          const errorMessage = error.error[0].message || 'Erro desconhecido.';
          this.poNotification.error(errorMessage);
        } else if (error.message) {
          this.poNotification.error(error.message);
        } else {
          this.poNotification.error('Ocorreu um erro ao gerar o boleto.');
        }
        this.isLoadingHidden = true;
      },
    );
  }

  generateBarCode(item: any) {
    if (!this.onValidToken()) return;

    this.apiService.postAction('GERAR_BARRAS').subscribe();
    this.codigoBarras = item.barCode;
    this.linhaDigitavel = item.digitableLine;

    if (item.barCode !== null || item.digitableLine !== null)
      this.modal1.open();
    else {
      this.poNotification.warning(
        'O código de barras e  a linha digitável não foram encontrados.',
      );
    }
  }

  generateQrCodePix(item: any) {
    this.isLoadingHidden = false;

    if (!this.onValidToken()) return;

    this.apiService.postAction('GERAR_QRCODE').subscribe();
    const body = item.invoice;
    let linkCopiaCola = '';

    if (item.qrCodePix) linkCopiaCola = item.qrCodePix;
    else {
      this.apiService.postPaymentLink(body).subscribe(
        (response) => {
          if (response.content !== '') {
            linkCopiaCola = response.content;
            item.qrCodePix = linkCopiaCola;
            this.qrCodeService.generateQrCode(linkCopiaCola).then((url) => {
              this.qrCodeImageUrl = url;
            });

            this.linkCopiaCola = linkCopiaCola;

            this.isLoadingHidden = true;
            this.modal2.open();
          } else {
            this.poNotification.warning(
              'Link Copia e Cola do Pix não foi encontrado.',
            );
            this.isLoadingHidden = true;
          }
        },
        (error) => {
          if (
            error.error &&
            Array.isArray(error.error) &&
            error.error.length > 0
          ) {
            const errorMessage = error.error[0].message || 'Erro desconhecido.';
            this.poNotification.error(errorMessage);
          } else if (error.message) {
            this.poNotification.error(error.message);
          } else {
            this.poNotification.error('Ocorreu um erro ao gerar o pix.');
          }
          this.isLoadingHidden = true;
        },
      );
    }

    if (linkCopiaCola) {
      this.qrCodeService.generateQrCode(linkCopiaCola).then((url) => {
        this.qrCodeImageUrl = url;
      });

      this.linkCopiaCola = linkCopiaCola;

      this.isLoadingHidden = true;
      this.modal2.open();
    }
  }

  customLiterals: PoTableLiterals = {
    noData: 'Nenhuma fatura encontrada!',
  };

  async copyToClipboard(elementId: string): Promise<void> {
    const inputElement = document.getElementById(elementId) as HTMLInputElement;
    if (inputElement) {
      try {
        await navigator.clipboard.writeText(inputElement.value);
      } catch (err) {
        this.poNotification.warning(`${err} - Erro ao copiar texto.`);
      }
    } else {
      this.poNotification.warning(`Elemento não encontrado: ${elementId}.`);
    }
  }

  private generateDocumentsIcons(item: any) {
    let listIcons = [];

    if (item.chargeType === 38) {
      listIcons.push('pdf');
      listIcons.push('barCode');
      listIcons.push('pix');
    } else if (item.barCode !== null) {
      listIcons.push('pdf');
      listIcons.push('barCode');
    } else if (
      item.chargeType === 37 ||
      (item.chargeType === 0 && item.hasTotvsRAC === true)
    ) {
      listIcons.push('pix');
    }

    return listIcons;
  }

  private onValidToken() {
    if (this.sessionService.isTokenExpiredOrNull().hasAccess !== true) {
      clearSessionData();
      this.router.navigate(['/login'], {
        queryParams: { tenant: this.tenantService.getTenant() },
      });
      return false;
    }

    return true;
  }

  changeColor(item: any) {
    const expiredDate = new Date(item.expiredDate);
    const currentDate = new Date();

    return expiredDate < currentDate === true ? 'color-07' : null;
  }

  showMore() {
    this.currentPage++;
    this.searchDocuments();
  }

  onPageChange(newPage: number, pageSize: number) {
    this.currentPage = newPage;
    this.pageSize = pageSize;

    this.searchDocuments();
  }

  getIconClass(type: string): string {
    const icons: any = {
      pdf: 'ph ph-file-pdf',
      barCode: 'ph ph-barcode',
      pix: 'ph ph-pix-logo',
    };
    return icons[type] || '';
  }

  getLabel(type: string): string {
    const labels: any = {
      pdf: 'PDF',
      barCode: 'Boleto',
      pix: 'Pix',
    };
    return labels[type] || '';
  }

  handleAction(type: string, item: any) {
    if (type === 'pdf') this.generatePDF(item);
    if (type === 'barCode') this.generateBarCode(item);
    if (type === 'pix') this.generateQrCodePix(item);
  }
}
